"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sourceSansPro = exports.lato = exports.fonts = exports.default = exports.XXLARGE = exports.XLARGE = exports.SMALL = exports.MEDIUM = exports.LARGE = exports.CONTENT_TYPES = void 0;
var SMALL = '12px';
exports.SMALL = SMALL;
var MEDIUM = '15px';
exports.MEDIUM = MEDIUM;
var LARGE = '20px';
exports.LARGE = LARGE;
var XLARGE = '24px';
exports.XLARGE = XLARGE;
var XXLARGE = '35px';
exports.XXLARGE = XXLARGE;
var sourceSansPro = 'Source Sans Pro';
exports.sourceSansPro = sourceSansPro;
var lato = 'Lato';
exports.lato = lato;
var fonts = {
  sourceSansPro: sourceSansPro,
  lato: lato
};
exports.fonts = fonts;
var CONTENT_TYPES = {
  PDF: 'pdf',
  POWERPOINT: 'ppt',
  WORD: 'doc',
  EXCEL: 'xls',
  KEYNOTE: 'key',
  TXT: 'txt',
  ZIP: 'zip'
};
exports.CONTENT_TYPES = CONTENT_TYPES;
var _default = {
  SMALL: SMALL,
  MEDIUM: MEDIUM,
  LARGE: LARGE,
  XLARGE: XLARGE,
  XXLARGE: XXLARGE,
  sourceSansPro: sourceSansPro,
  lato: lato,
  fonts: fonts,
  CONTENT_TYPES: CONTENT_TYPES
};
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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